// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__w1sJu","header":"MessagesList_header__9rUXI","chat":"MessagesList_chat__ydrec"};